import React from 'react';

import { DEFAULT_ICON_COLOR } from './config';
import { IconProps } from './iconTypes';

const CloseOutline = ({
  color = DEFAULT_ICON_COLOR,
  size = 18,
  className,
  style,
  title,
  onClick
}: IconProps) => (
  <div onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      height={size}
      style={style}
      viewBox="0 0 512 512"
    >
      <title>{title || 'Close'}</title>
      <path
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        d="M368 368L144 144M368 144L144 368"
      />
    </svg>
  </div>
);

export default CloseOutline;
